import React from 'react';
import { useGlobal } from 'reactn';
import { Table } from 'antd';
import DownloadIcon from '../../assets/download-icon-blue.svg';
import dayjs from 'dayjs';

import { formatDate, formatCurrencyNum } from '../../../helpers';

const CustomerSvcTable = ({ startDate, endDate }) => {
  const [serviceAccounts] = useGlobal('serviceAccounts');
  const [selectedServiceAccountIndex] = useGlobal(
    'selectedServiceAccountIndex'
  );
  const selectedServiceAccount = serviceAccounts[selectedServiceAccountIndex];
  // console.log({selectedServiceAccount})
  const pastBills = selectedServiceAccount?.billingHistory?.data;

  const columns = [
    {
      title: 'Bill Date',
      dataIndex: 'billDate',
    },
    {
      title: 'Billed Amount',
      dataIndex: 'billedAmount',
    },
    {
      title: 'Read Type Description',
      dataIndex: 'readTypeDesc',
    },
    {
      title: 'Current Read',
      dataIndex: 'currentRead',
    },
    {
      title: 'Billed Consumption',
      dataIndex: 'billedConsumption',
    },
    {
      title: 'View/Download Bill',
      dataIndex: 'viewBill',
    },
  ];

  const data = pastBills
    ?.filter(
      (f) =>
        dayjs(f.BILLDATE).isAfter(dayjs(startDate)) &&
        dayjs(f.BILLDATE).isBefore(dayjs(endDate))
    )
    .map((p, idx) => {
      return {
        key: `${idx + 1}`,
        billDate: formatDate(p.BILLDATE),
        billedAmount: formatCurrencyNum(p.BILLEDAMOUNT),
        readTypeDesc: p.READTYPEDESCR,
        currentRead: p.CURRENTREAD,
        billedConsumption: p.BILLEDCONSUMPTION,
        viewBill: (
          <a
            className="w-full flex justify-center"
            href={p.FILEKEY}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img className="h-5" src={DownloadIcon} alt="download-icon" />
          </a>
        ),
      };
    });

  return (
    <Table
      className="overflow-x-scroll"
      columns={columns}
      dataSource={data}
      pagination={false}
    />
  );
};

export default CustomerSvcTable;
